/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Registre } from '@/types';

import {
  validationInformationsActe,
  validationInformationsNaissance,
} from '..';

/**
 * Validation de l'étape 1 « Acte » : informations de l'acte + état civil de l'enfant.
 */
const validationStep1Naissance = (
  data: Record<string, any>,
  selectedRegistre?: Partial<Registre>,
) => ({
  ...validationInformationsActe(data, selectedRegistre),
  ...validationInformationsNaissance(data),
});

export default validationStep1Naissance;
